import React, {Component} from 'react';
import Dropzone from 'react-dropzone';
import TaggingField from './TaggingField';
import SearchField from './SearchField';
import i18n from "../../i18n";
import axios from 'axios';
import {remove, isEmpty} from 'lodash';
import swal from 'sweetalert';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid/Grid";
import SetRelations from "./SetRelations";
import _ from "lodash";
import EllipisWithTooltip from "../Formater/EllipsisWithTooltip";
import PreviewButton from "../File/PreviewButton";


const styles = theme => ({
        preview: {
            height: 120,
            width: 160,
        },
        searchBar: {
            textAlign: "right",
        },
        fileicon: {
            height: 120,
            width: 160,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            color: theme.colors.lightGreyBlue,
        },
        fileiconIcon: {
            height: 50,
            width: 50,
            "background-size": "inherit",
        },
        fileiconExt: {
            textAlign: "center",
        },
        card: {
            // display: 'flex',
            position: 'relative',
            borderRadius: 4,
            border: `solid 1px ${theme.colors.paleGray}`,
            marginBottom: 20,
            // padding: "1.9rem",
            boxShadow: "inherit",
        },
        isDeleted: {
            display: "none",
        },
        isPic: {},
        isNew: {},
        downloadButton: {
            width: "100%",
        },
        details: {
            display: 'flex',
            flexDirection: 'row',
            padding: 0,
            margin: "0 30px 0 0",
            "&:last-child": {
                padding: 0,
            }
        },
        detailsLabel: {
            "text-align": "right",
        },
        detailsRow: {
            "padding-top": 0,
            "padding-bottom": 0,
        },
        content: {
            // flex: '1 0 auto',
            // width: 350,
            // padding: 0,
            // margin: 0,
        },
        deleteFile: {
            position: 'absolute',
            right: 0,
            top: 0,
            padding: 0,
            minWidth: 20,
            minHeight: 20,
        },
        paper: {
            padding: "1.9rem",
        },
        dropzone: {
            width: '100%',
            height: 300,
            color: theme.colors.lightGreyBlue,
            display: "flex",
            flex: '1 0 auto',
            textAlign: "center",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            backgroundColor: theme.colors.paleGray,
        },
        dropzoneIcon: {
            fontSize: 86,
            color: theme.colors.lightGreyBlue,
        },
        deleteFileIcon: {
            fontSize: 20,
        },
        relationListButton: {
            position: 'relative',
        },
        relationListDelete: {
            position: 'absolute',
            top: 0,
            right: 0,
            fontSize: 18,
            marginTop: -8,
            marginRight: -8,
        },
        tags: {
            // flex: '1 0 auto',
            // marginRight: 30,
        },
        tagsInput: {
            width: "100%",
        },
        buttons: {
            // flex: '1 0 auto',
            width: "100%",
            margin: "15px 0 0 0",
            "& button": {
                marginBottom: theme.spacing.unit * 1,
            }
        },
        vSpace: {
            marginTop: theme.spacing.unit * 4,
            marginBottom: theme.spacing.unit * 2,
        },
        iconSpace: {
            marginRight: theme.spacing.unit * 0.5,
            marginLeft: theme.spacing.unit * 0.5,
        },
    })
;

/**
 * https://react-dropzone.js.org/
 */
class MediaDropZone extends Component {

    constructor(props) {
        super();
        const uploadConfig = Object.assign({
            'urlUnlink': null,
            'urlLink': null,
            'urlSearch': null,
            'url': null,
            'urlTag': null,
            'files': [],
            'tab': 0,
        }, props.uploadConfig);

        if (props.onNewFile) {
            this.onNewFile = props.onNewFile;
        }

        this.state = {
            searchQuery: '',
            tab: props.uploadConfig.tab || 0,
            files: props.uploadConfig.files,
            uploadConfig: uploadConfig,
            searchedFiles: [],
        };
    }

    onNewFile = null;

    refreshFilesState(newfiles) {
        if (!newfiles) {
            newfiles = [];
        }
        this.setState({
            files: [].concat(newfiles, this.state.files),
        });
    }

    updateFileRelations(updatedfile) {
        let files = this.state.files;
        _.each(files, (file) => {
            if (file.iId === updatedfile.iId) {
                file.aRelations = updatedfile.aRelations;
            }
        });
        this.setState({
            files: files,
        });
    }

    doUnlink(rel, idx, file) {
        swal({
            title: i18n.get('file.relations.label'),
            text: i18n.get('file.relations.question'),
            dangerMode: true,
            icon: "warning",
            buttons: [
                i18n.get('default.cancel'),
                i18n.get('default.delete'),
            ],
        }).then((confirmed) => {
            if (confirmed) {
                axios.delete(this.state.uploadConfig.urlUnlink, {data: {relid: rel.id}})
                    .then((response) => {
                        swal({
                            text: i18n.get('file.relations.removed'),
                            icon: "success",
                        }).then(() => {
                            _.remove(file.aRelations, (itm, relidx) => {
                                return idx === relidx;
                            });
                            this.refreshFilesState();
                        });
                    });
            }
        });
    }

    doAutoLink(file) {
        if (!isEmpty(this.state.uploadConfig.urlLink)) { // darf automatisch linken
            axios.post(this.state.uploadConfig.urlLink, {'file_id': [file.sHash]})
                .then((response) => {
                    if (response.data && response.data.refs) {
                        file.aRelations = [].concat(response.data.refs, file.aRelations);
                    }
                    this.refreshFilesState();
                });
        }
    }

    onChangeTab = (event, value) => {
        this.setState({tab: value});
    };


    onChangeTags(file, e) {
        file.sTags = e.target.value;
        this.refreshFilesState();
    }

    doSearch(q) {
        // Todo: start Animation
        axios.get(this.state.uploadConfig.urlSearch, {params: {q}})
            .then((response) => {
                // Todo: Stop Animation
                if (response.data && response.data.aResultsFiles) {
                    this.setState({
                        searchedFiles: response.data.aResultsFiles,
                        tab: 1,
                    });
                }
            })
            .catch(function (error) {
                // Todo Handle Error
                // Todo: Stop Animation
            });
    }

    onBlurTags(file) {
        axios.post(this.state.uploadConfig.urlTag, {'file_id': file.sHash, 'tags': file.sTags})
            .then((response) => {
                // done do nothing
            });
    }

    onDeleteFile(file) {
        // TODO: ggf. abfrage welche Relationen und Dateien noch vorhanden sind?
        swal({
            title: i18n.get('file.delete.label'),
            text: i18n.get('file.delete.question'),
            dangerMode: true,
            icon: "warning",
            buttons: [
                i18n.get('default.cancel'),
                i18n.get('default.delete'),
            ],
        }).then((confirmed) => {
            if (confirmed) {
                axios.delete(file.sRouteDelete, {})
                    .then((response) => {
                        if (response.data && response.data.success) {
                            file.isDeleted = true;
                            this.refreshFilesState();
                        }
                    });
            }
        });
    }


    onDrop(newfiles) {
        const config = {headers: {'Content-Type': 'multipart/form-data'}};
        let fd = new FormData();

        newfiles.map((file) => {
            fd.append('File[]', file);
        });

        axios.post(this.state.uploadConfig.url, fd, config)
            .then((response) => {
                newfiles.map((file, idx) => {
                    if (response.data && response.data.file_id && response.data.file_id.length > idx) {
                        try {
                            file.sHash = response.data.file_id[idx] || '';
                            file.icon = response.data.icons[idx] || '';
                            file.isImage = response.data.pics[idx] || '';
                            file.mcePic = response.data.mcePic[idx] || '';
                            file.sPrevPic = response.data.prevPic[idx] || '';
                            file.sTags = response.data.tags[idx] || '';
                            file.sExt = response.data.ext[idx] || '';
                            file.isNew = true;
                            file.isDeleted = false;

                            this.doAutoLink(file);
                            if (this.onNewFile) {
                                this.onNewFile(file);
                            }
                        } catch (ex) {
                            console.error(ex);
                        }
                    }
                });
                this.refreshFilesState(newfiles);
            })
            .catch(error => {
                console.error(error);
            })
    }

    renderRelations(file, classes) {
        return (
            <List>
                {
                    file.aRelations ? (
                        file.aRelations.length > 0 ? file.aRelations.map((rel, idx) => (
                                this.renderRelation(file, rel, idx, classes)
                            )
                        ) : ''
                    ) : ''
                }
            </List>
        );
    }

    renderRelation(file, rel, idx, classes) {
        return (
            <ListItem key={rel.id || Math.random()} className={classes.relationList}>
                <Button variant="outlined" className={classes.relationListButton}
                        onClick={this.doUnlink.bind(this, rel, idx, file)}>
                    <span>{rel.name}</span>
                    <Icon className={classes.relationListDelete}>highlight_off</Icon>
                </Button>
            </ListItem>
        );
    }

    renderTags(file, classes) {
        if (file) {
            if (!file.sTags) {
                file.sTags = '';
            }
            return (
                <TaggingField
                    className={classes.tagsInput}
                    onChange={this.onChangeTags.bind(this, file)}
                    onBlur={this.onBlurTags.bind(this, file)}
                    file={file}
                    label={i18n.get('file.tag.input.placeholder')}
                    title={i18n.get('file.tag.input.title')}
                    helperText={i18n.get('file.tag.input.helper')}
                />
            );
        }
        return null;
    }

    renderSearch() {
        return (
            <div className={this.props.classes.searchBar}>
                <SearchField
                    doSearch={this.doSearch.bind(this)}
                    value={this.state.searchQuery}
                    label={i18n.get('file.search.placeholder')}
                />
            </div>
        );
    }

    renderDetailsRow(label, value, classes) {
        return (
            <ListItem key={Math.random()} dense className={classes.detailsRow}>
                <Grid container spacing={24}>
                    <Grid item xs={6}>
                        <ListItemText primary={(<EllipisWithTooltip>{label}</EllipisWithTooltip>)}
                                      className={classes.detailsLabel}/>
                    </Grid>
                    <Grid item xs={6}>
                        <ListItemText primary={(<EllipisWithTooltip>{value}</EllipisWithTooltip>)}
                                      className={classes.detailsValue}/>
                    </Grid>
                </Grid>
            </ListItem>
        );
    }

    renderDetails(file, classes) {
        if (file) {
            return (
                <List>
                    {this.renderDetailsRow(i18n.get('file.details.name'), file.sName || file.name || '-', classes)}
                    {this.renderDetailsRow(i18n.get('file.details.uploaded'), file.sCreated || '-', classes)}
                    {this.renderDetailsRow(i18n.get('file.details.uploadedBy'), file.oCreator ? file.oCreator.name : '-', classes)}
                    {this.renderDetailsRow(i18n.get('file.details.relations'), (
                        file.aRelations ? (
                            file.aRelations.length > 0 ? file.aRelations.map((rel, idx) => (
                                <span key={idx}>
                                    {(idx !== 0 ? ', ' : '') + (rel.name || '')}
                                </span>
                            )) : '-'
                        ) : '-'
                    ), classes)}
                </List>
            );
        }
        return null;
    }

    renderPreview(file) {
        if (!file.icon) {
            file.icon = 'file-regular';
        }
        if (file && file.sPrevPic) {
            return (
                <Grid container
                      spacing={0}
                      className={this.props.classes.preview}
                      direction="row"
                      justify="center"
                      alignItems="center"
                >
                    <Grid item xs={12}>
                        <PreviewButton
                            file={file}
                        />
                    </Grid>
                </Grid>
            );
        }
        return (
            <div className={this.props.classes.fileicon}>
                <CardMedia
                    className={this.props.classes.fileiconIcon}
                    image={"/images/filetype/" + file.icon + ".svg"}
                    title=""
                />
                <div className={this.props.classes.fileiconExt} color="primary">{file.sExt}</div>
            </div>
        );
    }

    renderDelete(file, classes) {
        if (file) {
            return <Button variant="outlined" color="primary" className={classes.deleteFile}
                           onClick={this.onDeleteFile.bind(this, file)}><Icon>clear</Icon></Button>
        }
        return null;
    }

    renderDownload(file, classes) {
        if (file && file.sRoute) {
            return (
                <a href={file.sRoute} className={classes.downloadButton}>
                    <Button variant="contained" color="primary" className={classes.downloadButton}>
                        <Icon className={classes.iconSpace}>cloud_download</Icon>
                        Download
                    </Button>
                </a>
            );
        }
        return null;
    }

    renderSetRelation(file, classes) {
        if (file) {
            return (
                <SetRelations
                    file={file}
                    urlLinkOverlay={this.state.uploadConfig.urlLinkOverlay}
                    urlLinkOverlaySearch={this.state.uploadConfig.urlLinkOverlaySearch}
                    updateFileRelations={this.updateFileRelations.bind(this)}
                />
            );
        }
        return null;
    }

    renderFile(file) {
        if (file) {
            let classes = this.props.classes;
            let cardclasses = classes.card;
            cardclasses += (file.isDeleted ? ' ' + classes.isDeleted : '');
            cardclasses += (file.isImage ? ' ' + file.isPic : '');
            cardclasses += (file.isNew ? ' ' + classes.isNew : '');

            return (
                <Card key={file.sHash || file.sName || file.filename || Math.random()}
                      raised={false}
                      className={cardclasses}>
                    <CardContent className={this.props.classes.details}>
                        {this.renderPreview(file)}
                        <Grid container spacing={24}>
                            <Grid item xs={5}>
                                <div className={this.props.classes.content}>
                                    {this.renderDetails(file, this.props.classes)}
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                <div className={this.props.classes.tags}>
                                    {this.renderTags(file, this.props.classes)}
                                    {this.renderRelations(file, this.props.classes)}
                                </div>
                            </Grid>
                            <Grid item xs={3}>
                                <div className={this.props.classes.buttons}>
                                    {this.renderDelete(file, this.props.classes)}
                                    {this.renderSetRelation(file, this.props.classes)}
                                    {this.renderDownload(file, this.props.classes)}
                                </div>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            );
        }
        return null;
    }

    render() {
        return (
            <div className="dropZoneSection">
                <Typography variant="h2" className={this.props.classes.vSpace}>{i18n.get('file.upload')}</Typography>
                <Paper className={this.props.classes.paper}>
                    <Dropzone onDrop={this.onDrop.bind(this)} multiple={true} className={this.props.classes.dropzone}>
                        <Icon className={this.props.classes.dropzoneIcon}>cloud_upload</Icon>
                        <p>{i18n.get('file.drop')}</p>
                        <Button variant="contained" color='primary'>{i18n.get('file.select')}</Button>
                    </Dropzone>
                </Paper>
                {this.renderSearch()}
                <Typography variant="h2" className={this.props.classes.vSpace}>{i18n.get('file.title')}</Typography>
                <Paper className={this.props.classes.paper}>
                    <Tabs value={this.state.tab} onChange={this.onChangeTab.bind(this)}>
                        <Tab label={i18n.get('file.search.all')}/>
                        {/*<Tab label={i18n.get('file.search.pictures')}/>*/}
                        <Tab label={i18n.get('file.search.results')}/>
                    </Tabs>
                    {this.state.tab === 0 && <Typography component="div">{
                        [].concat(this.state.files).sort((a, b) => {
                            if (a && b && a.iCreated === b.iCreated) {
                                return 0;
                            }
                            return (a && b && a.iCreated > b.iCreated ? -1 : 1);
                        }).map(f => (
                            this.renderFile(f)
                        ))
                    }</Typography>}
                    {/*{this.state.tab === 1 && <Typography component="div">Fotos</Typography>}*/}
                    {this.state.tab === 1 && <div>{(
                        this.state.searchedFiles.length > 0 ? this.state.searchedFiles.map(f => (
                            this.renderFile(f)
                        )) : <span>{i18n.get('file.search.empty')}</span>)
                    }</div>}
                </Paper>
            </div>
        );
    }
}

MediaDropZone.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MediaDropZone);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Media/DropZone.js